import React from "react";
import { CheckSquare, QrCode, Save } from "lucide-react";
import {
  getAttendanceBulkThemeBgClass,
  getAttendanceMobileBulkStatusButtonClass,
} from "./attendanceMobileStyles";

export default function AttendanceDailyBulkActionBar({
  bulkHoverState,
  filteredCount,
  handleBulkStatusChange,
  handleClearSelection,
  handleSaveDaily,
  handleSelectAll,
  handleSyncSoteria,
  isMobile,
  isSoteriaLoading,
  selectedCount,
  setBulkHoverState,
  theme,
}) {
  const [flashStatus, setFlashStatus] = React.useState(null);

  const onBulkClick = (status) => {
    handleBulkStatusChange(status);
    setFlashStatus(status);
    setTimeout(() => setFlashStatus(null), 600);
  };

  const currentBgClass = flashStatus
    ? getAttendanceBulkThemeBgClass(flashStatus, theme.bg)
    : theme.bg;

  const containerClass = isMobile
    ? "pb-3 mx-2 transition-all duration-300 flex items-stretch gap-1.5"
    : "mb-4 sticky top-0 z-30 transition-all duration-300 flex items-stretch gap-1.5 mx-1";

  return (
    <div className={containerClass}>
      <div className={`flex-1 backdrop-blur-xl text-white rounded-[2rem] flex items-center justify-between shadow-2xl border border-white/20 ring-1 ring-black/5 transition-all duration-300 ease-out ${currentBgClass} ${isMobile ? "p-1.5 pl-2.5 pr-1.5" : "p-2 pl-5 pr-2"}`}>
        <div className="flex items-center gap-1.5 md:gap-3 flex-shrink-0">
          <div className={`bg-white/20 rounded-full flex items-center justify-center ${isMobile ? "p-1 w-5 h-5" : "p-1.5"}`}>
            <CheckSquare size={isMobile ? 12 : 18} className="text-white" />
          </div>
          <span className={`font-bold tracking-tight ${isMobile ? "text-[11px]" : "text-sm"}`}>{selectedCount}<span className="hidden xs:inline">명</span><span className="hidden md:inline"> 선택됨</span></span>
          <div className="flex items-center gap-1 ml-0.5">
            <button onClick={handleSelectAll} className={`font-bold bg-white/20 hover:bg-white/30 rounded-lg text-white transition flex-shrink-0 ${isMobile ? "text-[9px] px-1.5 py-0.5" : "text-[11px] px-2 py-0.5"}`}>
              {selectedCount === filteredCount ? "해제" : "전체"}
            </button>
            {selectedCount > 0 && (
              <button onClick={handleClearSelection} className={`font-bold bg-rose-500/40 hover:bg-rose-500/60 rounded-lg text-white transition flex-shrink-0 ${isMobile ? "text-[9px] px-1.5 py-0.5" : "text-[11px] px-2 py-0.5"}`}>
                초기화
              </button>
            )}
          </div>
        </div>
        <div className={`flex ${isMobile ? "gap-1" : "gap-1.5"} flex-shrink-0`}>
          <button
            onClick={() => onBulkClick("present")}
            className={getAttendanceMobileBulkStatusButtonClass("present", isMobile)}
          >
            <div className="w-1.5 h-1.5 rounded-full bg-white/80 shadow-sm"></div>
            출석
          </button>
          <button
            onClick={() => onBulkClick("late")}
            className={getAttendanceMobileBulkStatusButtonClass("late", isMobile)}
          >
            <div className="w-1.5 h-1.5 rounded-full bg-white/80 shadow-sm"></div>
            지각
          </button>
          <button
            onClick={() => onBulkClick("absent")}
            className={getAttendanceMobileBulkStatusButtonClass("absent", isMobile)}
          >
            <div className="w-1.5 h-1.5 rounded-full bg-white/80 shadow-sm"></div>
            결석
          </button>
        </div>
      </div>

      <button onClick={handleSaveDaily} className={`${currentBgClass} text-white rounded-[2rem] shadow-2xl transition-all duration-300 flex items-center justify-center gap-2 border border-white/20 ring-1 ring-black/5 active:scale-95 group ${isMobile ? "px-3.5 min-w-[3rem]" : "px-6"}`}>
        <Save size={isMobile ? 16 : 20} className="group-hover:animate-pulse" />
        {!isMobile && <span className="font-black text-base">저장</span>}
      </button>
    </div>
  );
}
